<template>
  <section class="catalog-hero" ref="root">
    <div class="catalog-hero__inner" :class="{ 'catalog-hero__inner_visible': visible }">
      <h1 class="catalog-hero__title">Наши работы</h1>
      <p class="catalog-hero__subtitle">
        Примеры работ по размерам рамок. Нажмите на изображение, чтобы открыть крупным планом.
      </p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'CatalogHero',
  setup() {
    const root = ref(null)
    const visible = ref(false)

    onMounted(() => {
      requestAnimationFrame(() => { visible.value = true })
    })

    return { root, visible }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";

$dur: 0.7s;
$ease: cubic-bezier(0.22, 1, 0.36, 1);

.catalog-hero {
  padding: 100px $gap 64px;
  background: $color-bg-alt;
  color: $color-primary-inverse;

  @media (max-width: $breakpoint-mobile) {
    padding: 72px $gap 48px;
  }

  &__inner {
    max-width: $container-max;
    margin: 0 auto;
    text-align: center;
  }

  &__title {
    font-size: clamp(32px, 5vw, 44px);
    font-weight: 800;
    letter-spacing: -0.02em;
    margin: 0 0 16px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $dur $ease, transform $dur $ease;

    .catalog-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__subtitle {
    font-size: clamp(15px, 1.8vw, 17px);
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease, transform $dur $ease;
    transition-delay: 0.08s;

    .catalog-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
